// import Head from "next/head";
import Page from "../../../components/Page";
// import { useRouter } from "next/router";
// import YouTubeEmbed from "../../../components/YouTubeEmbed";

import { useParams } from "react-router-dom";

const assignments: Array<Assignment> = [
    {
        name: "Assignment 1",
        description: "This is assignment 1",
        due: "2024-10-08",
        id: "1",
    },
];

const AssignmentPage = () => {
    // const router = useRouter();
    // const id: string = (router.query.id || "1").toString();
    // const id: number = 0;

    const params = useParams();
    const id: number = (params.id || 1) as number;

    const assignmentExist = assignments[id] !== undefined;

    if (assignmentExist) {
        return (
            <>
                <head>
                    <title>Math with Maki</title>
                    <meta name="description" content="Math with Maki" />
                    <link rel="icon" href="/favicon.ico" />
                </head>
                <Page href="math150">
                    <h1>{assignments[id].name}</h1>
                    <br></br>
                    <p>{assignments[id].description}</p>
                    <br></br>
                </Page>
            </>
        );
    } else {
        return (
            <>
                <head>
                    <title>Math with Maki</title>
                    <meta name="description" content="Math with Maki" />
                    <link rel="icon" href="/favicon.ico" />
                </head>
                <Page href="math150">
                    <h1>Assignment not found</h1>
                </Page>
            </>
        );
    }
};

export default AssignmentPage;
